import React, {Component} from 'react';
import {Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import * as moment from "moment";

class Dashboard extends Component {
    render() {
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div>
                                <div className="col-mid-12 no-padd">
                                    <div className="card title-card-bottom-space">
                                        <div className="header">
                                            <h4 className="title">Service Dashboard</h4>
                                            <p className="category"></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix"></div>

                                <div className="col-lg-3">
                                    <div className="card">
                                        <div className="content text-center">
                                            <Link className=""   to="#">
                                                <div className="report-thumbs-ico">
                                                    <div className="icon-big text-center folder-icon">
                                                        <i className="fa fa-folder-o"></i>
                                                    </div>
                                                    <h5>Create Support Ticket</h5>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3">
                                    <div className="card">
                                        <div className="content text-center">
                                            <Link className=""   to="#">
                                                <div className="report-thumbs-ico">
                                                    <div className="icon-big text-center folder-icon">
                                                        <i className="fa fa-folder-o"></i>
                                                    </div>
                                                    <h5>View Ticket Status</h5>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3">
                                    <div className="card">
                                        <div className="content text-center">
                                            <Link className=""   to="#">
                                                <div className="report-thumbs-ico">
                                                    <div className="icon-big text-center folder-icon">
                                                        <i className="fa fa-folder-o"></i>
                                                    </div>
                                                    <h5>Support Ticket Summary</h5>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3">
                                    <div className="card">
                                        <div className="content text-center">
                                            <Link className=""   to="#">
                                                <div className="report-thumbs-ico">
                                                    <div className="icon-big text-center folder-icon">
                                                        <i className="fa fa-folder-o"></i>
                                                    </div>
                                                    <h5>Innoviti Support Modes</h5>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Dashboard;
